// Slug for AI Virtual Staging. Verified against the live QA
// GET /product-service/api/v1/services?servicesType=asset response
// (matches the backend tests' `ai_virtual_staging_edit`).
export const AI_VIRTUAL_STAGING_SLUG = 'ai_virtual_staging_edit';

// AC7: AI Virtual Staging needs no description; pre-fill this so the field
// validates without forcing the user to type.
export const AI_VIRTUAL_STAGING_NOTE = 'No description required for AI Virtual Staging';
